module.exports = __webpack_public_path__ + "img/51-2.38366b5d.png";